import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "xmqwo5az",
  dataset: "production",
});
